import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { EXPENSE_APPROVED_ITEMS_BASE_KEY } from '@webapp/modules/expense/query-configs/expense'

export const useMutateCorrectExpenseItemAccountCodes = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    void,
    RepoError,
    { expenseItemId: number; accountId: number }[]
  >({
    mutationFn: (corrections) =>
      expenseRepository.correctItemBudgets(corrections),
    onSuccess: () => {
      // Matches every listApprovedItems param variant; deliberately does NOT
      // touch the sibling 'approved-items-count' badge key
      queryClient.invalidateQueries({
        queryKey: EXPENSE_APPROVED_ITEMS_BASE_KEY,
      })
    },
  })

  return {
    correctAccountCodes: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
